import {DOCUMENT} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';

@Component({
    selector: 'app-partnerfaq',
    templateUrl: './partnerfaq.component.html',
    styleUrls: ['./partnerfaq.component.css'],
    providers: [ApiServiceService]
})
export class PartnerfaqComponent implements OnInit {
    finzyDomain = true;
    otherDomain = false;

    constructor(private apiService: ApiServiceService, private storageService: StorageService, @Inject(DOCUMENT) private document: any) {
    }

    ngOnInit() {
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
    }
}
